<template>
	<div class="manager-login-as"></div>
</template>

<script>
export default {
	mounted: function() {
		var userSearch = $('<div class="ui search"><div class="ui icon input"> <input class="prompt" placeholder="Login as..." type="text" /><i class="circular search icon"></i></div><div class="results" style="z-index: 100000;"></div></div>');
		userSearch.search({
			apiSettings: {
				url: 'ajax/getUsers.php?loggedIn=true&term={query}',
				onResponse(response) {
					response.results.forEach(user => {
						user.description = user.organizationName;
						if(user.parentOrgName) {
							user.description += ' - ' + user.parentOrgName;
						}
						user.price = user.role;
					});

					return response;
				}
			},
			minCharacters: 2,
			onSelect: function(result) {
				$.Confirm('Switch User', 'Do you want to switch to be logged in as ' + result.title + '?', function() {
					$('#pageLoading').addClass('active');
					$.ajax({
						url: 'ajax/switchUser.php',
						type: 'post',
						data: {
							userId: result.userId
						},
						dataType: 'json',
						success: function() {
							window.location = '/';
						},
						error: function(xhr) {
							$('#pageLoading').removeClass('active');

							var message = 'Failed to login as user';
							try {
								var data = JSON.parse(xhr.responseText);
								var reason = data.reason;
								if(reason != 'Plic error' && reason != 'Authentication error' && reason != 'Error from PLIC') {
									message = reason;
								}
							} catch(e) {
								console.error('Failed to parse message: ', e);
							}

							$.Alert('Error', message);
						}
					});
				});
			},
			cache: false
		});

		$(this.$el).append(userSearch);
	}
};
</script>

<style scoped>
.manager-login-as {
	margin: 0 0.5em;
}

.manager-login-as :deep(> .ui.search .result .price) {
	float: initial;
}
</style>